var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.4875,
    r: 18,
    stroke: "#B71C1C",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.989 24.6533C20.895 24.6533 20 23.8909 20 22.959V16.1818C20 15.25 20.895 14.4875 21.989 14.4875C23.0829 14.4875 23.9779 15.25 23.9779 16.1818V22.959C23.9779 23.8909 23.0829 24.6533 21.989 24.6533Z",
    fill: "#B71C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9779 28.8964C23.9779 29.7752 23.2655 30.4876 22.3867 30.4876H21.5912C20.7124 30.4876 20 29.7752 20 28.8964C20 28.0176 20.7124 27.3052 21.5912 27.3052H22.3867C23.2655 27.3052 23.9779 28.0176 23.9779 28.8964Z",
    fill: "#B71C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOver);
export default __webpack_public_path__ + "static/media/over.494e0c16abd2c7183c87d1f9c3e5172f.svg";
export { ForwardRef as ReactComponent };